<template>
	<div>
	<div class="mainContent">
		<div class="banner" id="main">
			<swiper :options="bannerSwiperOption" ref="bannerSwiper" id="swiper" :slides-per-view="30"
				:space-between="50">
				<swiper-slide v-for="(i, index) in bannerList" :key="index">
					<img :src="i.url" alt="" />
					<div id="info">
						<div class="w">
							<div>
								<p class="web-font-banner-info">{{ i.info1 }}</p>
								<p class="web-font-banner-info">{{ i.info2 }}</p>
							</div>
						</div>
					</div>
				</swiper-slide>
			</swiper>
			<span @click="changeBanner(1)" class="contralLeft contral"></span>
			<span @click="changeBanner(2)" class="contralRight contral"></span>
			<div class="paginationContainer">
				<div class="w">
					<div class="swiper-pagination"></div>
				</div>
			</div>
		</div>
		<div class="product fBox" id="product" style="">
			<div class="w">
				<h1 style="" class="web-font">产品服务</h1>
				<div class="content">
					<swiper :options="bannerSwiperOption1" ref="serviceSwiper" id="serviceSwiper" :slides-per-view="30"
						:space-between="50">
						<swiper-slide v-for="(i, index) in serviceList" :key="index">
							<div class="infoBox">
								<div class="icon">
									<img :src="i.url" alt="" />
								</div>
								<div class="title web-font-content-info">{{ i.title }}</div>
								<div class="info web-font-content-info">{{ i.info }}</div>
								<div class="info1 web-font-content-info">{{ i.info1 }}</div>
							</div>
							<div class="img"><img :src="i.imgUrl" alt="" /></div>
						</swiper-slide>
					</swiper>
					<div class="paginationContainer container">
						<div class="swiper-pagination1"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="businessScope fBox" style="">
			<div class="w" v-show="!isMobile">
				<h1 class="web-font">业务范围</h1>
				<div class="content">
					<div class="left">
						<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/businessscope.svg" alt="" />
					</div>
					<div class="right">
						<h4>伯才合作项目</h4>
						<p class="web-font-content-info">
							辐射18个省及直辖市，触达城市100+
						</p>
						<p class="web-font-content-info">
							覆盖华东、华南、华中、华北、西南、西北6大区域
						</p>
						<div>
							<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/辐射省份.svg" alt="" />
							<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/触达城市.svg" alt="" />
						</div>
						<div></div>
					</div>
				</div>
			</div>
			<div class="w" v-show="isMobile">
				<h1 class="web-font">业务范围</h1>
				<div class="content">
					<div class="right">
						<h4>伯才合作项目</h4>
						<p class="web-font-content-info">
							辐射18个省及直辖市，触达城市100+
						</p>
						<p class="web-font-content-info">
							覆盖华东、华南、华中、华北、西南、西北6大区域
						</p>
						<div>
							<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/辐射省份.svg" alt="" />
							<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/触达城市.svg" alt="" />
						</div>
					</div>
					<div class="left">
						<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/businessscope.svg" alt="" />
					</div>
				</div>
			</div>
		</div>
		<div class="brand fBox" style="">
			<h1 class="web-font">合作品牌</h1>
			<span>* 部分合作品牌展示</span>
			<div class="w">
				<div class="content">
					<ul class="">
						<li v-for="item in cooperativeImg" :key="item">
							<img :src="`../../../${item}`" alt="" />
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- <div class="partenship fBox" id="partenship" style="">
      <h1 class="web-font">平台合作</h1>
      <div class="content w pc" v-if="isMobileShow == false">
        <div>
          <i class="iconfont icon-zhaoren"></i>
          <h4>我要招人</h4>
          <p>用工企业、总包、派遣公司等</p>
          <button @click="showModal(1)" type="button">点击联系</button>
        </div>
        <a-modal :visible="modalVisible" destroyOnClose :footer="null" centered width="456px" @ok="cancelModal" @cancel="cancelModal">
          <template slot="title"> </template>
          <template v-if="!isSubmitRight">
            <p class="modalTitle">{{ modalText[modalType].modalTitle }}</p>
            <p class="modalContent">{{ modalText[modalType].modalContent }}</p>
            <a-form :form="submitForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }" labelAlign="left" @submit="handleSubmit">
              <a-form-item label="您的单位名称">
                <a-input placeholder="请输入您的单位名称" v-decorator="[
                    'companyName',
                    {
                      rules: [
                        { required: false, message: '请输入您的单位名称' },
                      ],
                    },
                  ]" />
              </a-form-item>
              <a-form-item label="您的称呼">
                <a-input placeholder="请输入您的称呼" v-decorator="[
                    'userName',
                    {
                      rules: [
                        { required: true, message: '请输入您的称呼' },
                        {
                          pattern: /^([\u4e00-\u9fa5|a-z]{1,6})$/,
                          message: '请输入1-6位长度的非数字昵称',
                        },
                      ],
                      validateTrigger: 'submit',
                    },
                  ]" />
              </a-form-item>
              <a-form-item label="联系电话">
                <a-input placeholder="请输入您的联系电话" v-decorator="[
                    'tel',
                    {
                      rules: [
                        { required: true, message: '请输入您的联系电话' },
                        {
                          pattern: /^1[34578]\d{9}$/,
                          message: '请输入正确的联系电话',
                        },
                      ],
                      validateTrigger: 'submit',
                    },
                  ]" />
              </a-form-item>
              <a-form-item label="备注">
                <a-textarea placeholder="请输入备注" :auto-size="{ minRows: 3, maxRows: 10 }" v-decorator="['desp']" />
              </a-form-item>
              <div class="submitContiner">
                <a-button type="primary" style="background-color: #027aff; width: 200px; height: 40px" @click="showVerification">提交</a-button>
                <a-modal :visible="verificationVisible" :footer="null" centered width="318px" @cancel="cancelVerification">
                  <p class="modalTitle" style="font-size: 18px; margin-bottom: 24px">
                    请拖动下边滑块
                  </p>
                  <manMachineVerification ref="verification" :isHuman.sync="isHuman"></manMachineVerification>
                  <p style="font-size: 14px; color: #999; margin-top: 12px">
                    验证通过后将提交您的信息
                  </p>
                  <div style="text-align: center; margin-top: 40px">
                    <a-button type="primary" :disabled="!isHuman" :loading="submitLoading" style="padding
                   : 0 20px height:32px" @click="handleSubmit($event,'desk')" html-type="submit">确定</a-button>
                  </div>
                </a-modal>
              </div>
            </a-form>
          </template>
          <div class="success" v-else>
            <div class="iconfont icon-tijiaochenggong"></div>
            <p>提交成功</p>
            <p>稍后公司同事会电话联系您</p>
            <a-button type="primary" style="
                background-color: #027aff;
                width: 200px;
                height: 46px;
                margin-top: 90px;
              " @click="closeFormModal">回首页</a-button>
          </div>
        </a-modal>
        <div>
          <i class="iconfont icon-songren"></i>
          <h4>我要送人</h4>
          <p>我有老乡资源，可以送人</p>
          <button @click="showModal(2)" type="button">点击联系</button>
        </div>
        <div>
          <i class="iconfont icon-ziyuan"></i>
          <h4>我有配套资源</h4>
          <p>我是人力资源服务业配套服务商，人才税法</p>
          <button @click="showModal(3)" type="button">点击联系</button>
        </div>
      </div>
      <div class="content w mobile" v-if="isMobileShow == true">
        <swiper :options="partenshipSwiperOption" ref="bannerSwiper" id="swiper" :slides-per-view="10" :space-between="10" @click="showMobileModal">
          <swiper-slide>
            <div>
              <i class="iconfont icon-zhaoren"></i>
              <h4>我要招人</h4>
              <p>用工企业、总包、派遣公司等</p>
              <button type="button" data-type='1'>点击联系</button>

            </div>
          </swiper-slide>
          <swiper-slide>
            <div>
              <i class="iconfont icon-songren"></i>
              <h4>我要送人</h4>
              <p>我有老乡资源，可以送人</p>
              <button type="button" data-type='2'>点击联系</button>

            </div>
          </swiper-slide>
          <swiper-slide>
            <div>
              <i class="iconfont icon-ziyuan"></i>
              <h4>我有配套资源</h4>
              <p>我是人力资源服务业配套服务商，人才税法</p>
              <button type="button" data-type='3'>点击联系</button>

            </div>
          </swiper-slide>
        </swiper>
        <a-drawer placement="bottom" destroyOnClose :closable="true" :visible="modalVisible" height='640' @close="cancelModal">
          <template slot="title"> </template>
          <template v-if="!isSubmitRight">
            <p class="modalTitle">{{ modalText[modalType].modalTitle || '' }}</p>
            <p class="modalContent">{{ modalText[modalType].modalContent || '' }}</p>
            <a-form :form="submitForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }" labelAlign="left" @submit="handleSubmit">
              <a-form-item label="您的单位名称">
                <a-input placeholder="请输入您的单位名称" v-decorator="[
                    'companyName',
                    {
                      rules: [
                        { required: false, message: '请输入您的单位名称' },
                      ],
                    },
                  ]" />
              </a-form-item>
              <a-form-item label="您的称呼">
                <a-input placeholder="请输入您的称呼" v-decorator="[
                    'userName',
                    {
                      rules: [
                        { required: true, message: '请输入您的称呼' },
                        {
                          pattern: /^([\u4e00-\u9fa5|a-z]{1,6})$/,
                          message: '请输入1-6位长度的非数字昵称',
                        },
                      ],
                      validateTrigger: 'submit',
                    },
                  ]" />
              </a-form-item>
              <a-form-item label="联系电话">
                <a-input placeholder="请输入您的联系电话" v-decorator="[
                    'tel',
                    {
                      rules: [
                        { required: true, message: '请输入您的联系电话' },
                        {
                          pattern: /^1[34578]\d{9}$/,
                          message: '请输入正确的联系电话',
                        },
                      ],
                      validateTrigger: 'submit',
                    },
                  ]" />
              </a-form-item>
              <a-form-item label="备注">
                <a-textarea placeholder="请输入备注" :auto-size="{ minRows: 3, maxRows: 10 }" v-decorator="['desp']" />
              </a-form-item>
              <div class="submitContiner">
                <a-button type="primary" style="background-color: #027aff; width: 200px; height: 46px" @click="showVerification">提交</a-button>
                <a-modal :visible="verificationVisible" :footer="null" centered width="318px" @cancel="cancelVerification">
                  <p class="modalTitle" style="font-size: 18px; margin-bottom: 24px">
                    请拖动下边滑块
                  </p>
                  <manMachineVerification ref="verification" :isHuman.sync="isHuman"></manMachineVerification>
                  <p style="font-size: 14px; color: #999; margin-top: 12px">
                    验证通过后将提交您的信息
                  </p>
                  <div style="text-align: center; margin-top: 40px">
                    <a-button type="primary" :disabled="!isHuman" :loading="submitLoading" style="padding
                   : 0 20px height:32px" @click="handleSubmit($event,'mobile')" html-type="submit">确定</a-button>
                  </div>
                </a-modal>
              </div>
            </a-form>
          </template>
        </a-drawer>
      </div> -->
		<div class="middlebanner" style="">
			<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/companyInfo.webp" alt="" />
		</div>
		<div class="aboutus" id="aboutusbox" style="text-align: center" v-show="!isMobile">
			<a-anchor @click.prevent="" :affix="false" :targetOffset="80">
				<a-anchor-link href="#guanyubocai" title="公司简介" />
				<a-anchor-link href="#yuanjingshiming" title="愿景及使命" />
				<a-anchor-link href="#qiyewenhua" title="企业文化" />
				<a-anchor-link href="#fazhanlicheng" title="发展历程" />
				<a-anchor-link href="#yewujiagou" title="公司架构" />
				<a-anchor-link href="#bangongdidian" title="公司地址" />
			</a-anchor>
		</div>
	</div>
	<div class="aboutbocai">
		<div class="bocai">
			<div class="guanyubocai fBox" id="guanyubocai" style="">
				<div class="w">
					<h1 class="web-font">公司简介</h1>
					<div class="tagBox">
						<a-tag :color="item.color + '22'" :style="{ color: item.color }"
							v-for="(item, index) in tagList" :key="index">{{ item.info }}</a-tag>
					</div>
					<div class="content">
						<div class="left">
							<p class="web-font-content-info">
								郑州伯才科技有限公司，是一家人力资源服务行业的数字化平台企业。
							</p>
							<p class="web-font-content-info">
								郑州伯才科技有限公司的前身为北京矩阵动力科技有限公司，项目于2015年5月在郑州启动，并于2016年5月在北京正式注册公司，开始商业化运作。
							</p>
              <!-- 伯才科技旗下有郑州伯才人力资源服务有限公司、江西人海企业管理有限公司等多家企业服务业务公司。 -->
							<p class="web-font-content-info">
								公司2021年启用全新品牌——伯才。新品牌、新征程，品牌升级，但初心不变，伯才团队以崭新的面貌继续全心全意服务老乡、成就伙伴。
							</p>
						</div>
						<div class="right">
							<img src="http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/gsjj.jpg" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="yuanjingshiming fBox" id="yuanjingshiming" style="">
				<div class="w">
					<h1 class="web-font">愿景及使命</h1>
					<div class="content">
						<div>
							<h4>企业愿景</h4>
							<div class="web-font-content-info">
								解决4亿蓝领的就业问题
							</div>
							<!-- <p class="web-font-content-info">解决4亿蓝领的就业问题</p>
                <p class="web-font-content-info">让企业用人像网约车一样简单</p> -->
						</div>
						<div>
							<h4>企业使命</h4>
							<div class="web-font-content-info">为劳动者创造价值</div>
						</div>
					</div>
				</div>
			</div>
			<div class="enterpriseCulture fBox" id="qiyewenhua">
				<div class="w">
					<h1 class="web-font">核心价值观</h1>
					<div class="content">
						<!-- <div class="content1">
								<div class="headline web-font">服务宗旨</div>
								<p class="web-font-content-info">全心全意为老乡服务</p>
							</div> -->
						<div class="content2">
							<!-- <div class="headline web-font">核心价值观</div> -->
							<ul v-if="!isMobile">
								<li :class="{ active: core == 1 }" @mouseenter="core = 1" @mouseleave="core = 0">
									<i class="iconfont icon-a-01"></i>
									<span>用户至上</span>
								</li>
								<li :class="{ active: core == 2 }" @mouseenter="core = 2" @mouseleave="core = 0">
									<i class="iconfont icon-a-02"></i>
									<span>开放协作</span>
								</li>
								<li :class="{ active: core == 3 }" @mouseenter="core = 3" @mouseleave="core = 0">
									<i class="iconfont icon-a-03"></i>
									<span>诚信正直</span>
								</li>
								<li :class="{ active: core == 4 }" @mouseenter="core = 4" @mouseleave="core = 0">
									<i class="iconfont icon-a-04"></i>
									<span>促成变化</span>
								</li>
								<li :class="{ active: core == 5 }" @mouseenter="core = 5" @mouseleave="core = 0">
									<i class="iconfont icon-a-05"></i>
									<span>争做第一</span>
								</li>
							</ul>
							<span v-else><img src="../../assets/bcSVG/核心价值观.svg" alt="" /></span>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="developmentHistory fBox" id="fazhanlicheng">
					<div class="head" style="">
						<div class="w">
							<h1>发展历程</h1>
							<ul class="timeAxle">
								<li v-for="(item, index) in swiperList" :key="index" :class="currentId == item.id ? 'active' : ''" @click="[(currentYear = item), (currentId = item.id)]">
									<p>{{ item.year }}</p>
								</li>
							</ul>
						</div>
					</div>
					<div class="body">
						<div class="w">
							<div class="title">{{ currentYear.year }}</div>
							<div class="content">
								<p v-for="(item, index) in currentYear.info" :key="index">{{ item }}</p>
							</div>
						</div>
					</div>
				</div> -->
			<div class="developmentHistory1 fBox" id="fazhanlicheng">
				<h1 class="web-font">发展历程</h1>
				<div class="w">
					<ul class="content" v-show="!isMobile">
						<li v-for="(item, index) in swiperList" :key="index">
							<ul>
								<span class="web-font-content-info">{{ item.year }}</span>
								<li v-for="(item1, index1) in item.info" :key="index1" class="web-font-content-info">
									{{ item1 }}
								</li>
							</ul>
						</li>
					</ul>
					<div v-show="isMobile">
						<img src="../../assets/bcSVG/发展历程.svg" alt="" />
					</div>
				</div>
			</div>
			<div class="yewujiagou fBox" id="yewujiagou" style="">
				<h1 class="web-font">公司架构</h1>
				<div class="content w"></div>
			</div>
			<div class="workSpace fBox" id="bangongdidian">
				<div class="w">
					<h1 class="web-font">公司地址</h1>
					<div class="content web-font-content-info">
						<div class="left" v-if="!isMobile">
							<div class="web-font-content-info">
								<div class="title">郑州伯才科技有限公司</div>
								<p>
									<i class="iconfont icon-dianhua"></i>电话：<span
										>0371-66113723</span>
								</p>
								<p>
									<i class="iconfont icon-dizhi"></i>河南省郑州市郑东新区升龙广场2号楼A座
								</p>
							</div>
							<!-- </div> -->
							<!-- <div :class="currentLocation == 1 ? 'active' : ''" @click="[changeLocation(2), (currentLocation = 1)]">
									<div><i class="iconfont icon-dianpu"></i></div>
									<div class="web-font-content-info">
										<div class="title">服务中心</div>
										<p>电话：0371-6611 3723</p>
										<p>河南郑州航空港区相州街29-60号（豫康新城-北区）</p>
									</div>
								</div> -->
						</div>

						<div class="left" v-else>
							<div class="web-font-content-info">
								<div class="title">总部地址</div>
								<p><i class="iconfont icon-dianhua"></i><span
										>0371-66113723</span></p>
								<p>
									<i class="iconfont icon-dizhi"></i>河南省郑州市郑东新区升龙广场2号楼A座
								</p>
							</div>
							<!-- <div :class="currentLocation == 1 ? 'active' : ''" @click="[changeLocation(2), (currentLocation = 1)]">
									<div class="web-font-content-info">
										<div class="title">
											服务中心
										</div>
										<p>0371-6688 8866</p>
										<p>河南郑州航空港区相州街29-60号(豫康新城-北区)</p>
									</div>
								</div> -->
						</div>
						<div class="right">
							<div class="my-map" v-show="currentLocation == 0">
								<gdmap :positionInfo="{
                      lng: 113.772207,
                      lat: 34.757083,
                      name: '伯才科技有限公司',
                      desc: '河南省郑州市郑东新区升龙广场2号楼A座',
                      containerName: 'mapContainer',
                      picUrl: require('../../assets/bcSVG/总部地址.png'),
                    }"></gdmap>
							</div>
							<!-- <div class="my-map" v-show="currentLocation == 1">
									<gdmap
										:positionInfo="{
											lng: 113.863823,
											lat: 34.571367,
											name: '服务中心',
											desc: '河南省郑州市航空港区相州街29-60号（豫康新城-北区）',
											containerName: 'mapContainer1',
											picUrl: require('../../assets/bcSVG/服务中心.png'),
										}"
									></gdmap>
								</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
	</div>
</template>

<script>
	// import Swiper from "swiper";
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import gdmap from "../../components/map.vue";
	import "swiper/dist/css/swiper.css";
	import manMachineVerification from "../../components/manMachineVerification.vue";
	const path = require("path");
	const files = require.context("../../assets/bcSVG/", false, /.*$/);
	import {
		sendForm
	} from "../../api/main";
	export default {
		inject: ["resets"],
		// 组件名称
		name: "contentContainer",
		// 局部注册的组件
		components: {
			swiper,
			swiperSlide,
			gdmap,
			manMachineVerification,
		},
		// 组件参数 接收来自父组件的数据
		props: {
			isMobile: {
				require: true,
			},
		},
		// 组件状态值
		data() {
			return {
				bannerSwiper: null,
				serviceActive: 1,
				cooperativeImg: [],
				reset: true,
				isMobileShow: false,
				isMapContainer: false,
				isMapContainer1: false,
				core: 0,
				submitForm: this.$form.createForm(this),
				modalType: 1, // 表单提交类型
				verificationVisible: false, // 人机验证提示框显示
				isSubmitRight: false, // 提交成功显示
				isHuman: false, //是否验证通过
				submitLoading: false, // 表单提交的loading状态
				modalText: {
					// 表单提示文本内容 
					1: {
						modalTitle: "我要招人",
						modalContent: "如您有用工需求，可以留下您的联系方式，我们同事看到留言后第一时间联系您。",
						modalType: 1,
					},
					2: {
						modalTitle: "我要送人",
						modalContent: "如您有老乡、学生等人力资源希望对外输送，可以留下您的联系方式，我们同事看到留言后第一时间联系您。",
						modalType: 2,
					},
					3: {
						modalTitle: "我有配套资源",
						modalContent: "如您能够提供产品或者服务，可以留下您的联系方式，我们同事看到留言后第一时间联系您。",
						modalType: 3,
					},
				},
				modalVisible: false,
				bannerList: [{
						url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/banner3.jpg",
						info1: "伯才",
						info2: "为劳动者创造价值",
					},
					{
						url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/banner2.jpg",
						info1: "伯才供应链",
						info2: "人力资源供应链平台",
					},
					// {
					// 	url: "http://matripe.oss-cn-beijing.aliyuncs.com/yishoudan/newBanner/banner1.webp",
					// 	info1: "伯才稻田",
					// 	info2: "让天下没有难做的劳务",
					// },
					// {
					//   url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/banner4.jpg",
					//   info1: "稻田代理",
					//   info2: "赋能伙伴 合作共赢",
					// },
					// {
					// 	url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/banner5.webp",
					// 	info1: "结算助手",
					// 	info2: "智能结算 又快又准",
					// },
				],
				currentYear: {
					year: "2015",
					info: ["2015年05月，项目启动，开启了为劳动者创造价值的征程"],
				},
				currentId: 0,
				currentLocation: 0,

				tagList: [{
						color: "#027AFF",
						info: "企业服务"
					},
					{
						color: "#00CC02",
						info: "产业中台"
					},
					{
						color: "#FE6B01",
						info: "产业路由器"
					},
					{
						color: "#DB2929",
						info: "智能招聘"
					},
					{
						color: "#9B05EF",
						info: "协同网络"
					},
					{
						color: "#B5004B",
						info: "基础岗蓝领"
					},
					{
						color: "#006EE6",
						info: "S2b2C"
					},
					{
						color: "#00CC02",
						info: "下沉市场"
					},
				],
				swiperList: [{
						id: 0,
						year: "2015",
						info: [
							"2015年05月，项目启动，开启了为劳动者创造价值的征程",
							"2016年05月，在北京注册成立公司，开始公司化运作",
							"2016年12月，打勾直通车上线"
						],
					},
					// {
					// 	id: 1,
					// 	year: "2016",
					// 	info: [],
					// },
					{
						id: 2,
						year: "2017",
						info: [
							"2017年07月，RPO业务启动",
							"2018年12月，交付中心独立运营",
							"2020年01月，打勾人力资源供应链协同网络平台上线"

						],
					},
					{
						id: 3,
						year: "2021",
						info: [
							"2021年09月，稻田代理上线",
							"2021年10月，启用“伯才”品牌，“打勾”全面升级为“伯才”",
							"2022年04月，伯才一手单平台上线",
							"2022年09月，稻田代理和伯才一手单合并升级为稻田2.0",
							"2022年10月，驻场通上线"
						],
					},
					{
						id: 4,
						year: "2023",
						info: [
							"2023年03月，伯才智能终端3件套发布",
							"2023年10月，稻田3.0，让天下没有难做的劳务"
						],
					},
				],

				serviceList: [{
						id: 1,
						url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/伯才供应链.svg",
						imgUrl: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/service-bcgyl.svg",
						info: "人力资源供应链平台",
						info1: "伯才供应链是一个基于人工智能搭建的人力资源供应链平台，同时也是一个S2b2C模式的产业中台。伯才供应链产品矩阵包含伯才网、职位云、哪吒AI、稻田、伯才用人、结算助手等。",
						title: "伯才供应链",
					},
					{
						id: 2,
						url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/哪吒.svg",
						imgUrl: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/service-bcdt.svg",
						info: "智能匹配  精准高效",
						info1: "哪吒AI是一个以脑科学、认知心理学为理论支撑，基于仿生涌现架构开发的认知计算引擎，哪吒AI在对“求职者”和“工作岗位”进行建模的基础上，实现高效、精准的“人岗匹配”，哪吒AI引擎是伯才人力资源供应链平台的核心基础设施。",
						title: "哪吒AI",
					},
					{
						id: 4,
						url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/职位云.svg",
						imgUrl: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/service-bc.svg",
						info: "为劳动者创造价值",
						info1: "职位云是一个为项目职位信息管理与协作服务的中台产品，职位云通过CDN架构实现项目职位信息采集、编辑的质量和进度控制，为多渠道的分发触达提供基础能力，最终保障项目信息更新的及时、准确和完整。职位云是伯才人力资源供应链产品矩阵的核心。",
						title: "职位云",
					},
					// {
					// 	id: 3,
					// 	url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/稻田.svg",
					// 	imgUrl: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/service-bcysd.svg",
					// 	info: "让天下没有难做的劳务",
					// 	info1: "伯才稻田是一个专门服务同业合作伙伴的综合平台，稻田的使命是让天下没有难做的劳务。稻田为用户提供项目发布、老乡报名、工单跟踪、财务结算、服务评价等一站式服务，同时也为合作伙伴提供内容分发及流量分佣。伯才稻田秉承“资源共享、伙伴共赢”的理念，与合作伙伴一道，共同创造人力资源行业的新发展，共同分享人力资源市场的新红利，共同赢得人力资源事业的新未来。",
					// 	title: "伯才稻田",
					// },
					// {
					// 	id: 6,
					// 	url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/jszs.svg",
					// 	imgUrl: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/service-jszs.svg",
					// 	info: "智能结算 又快又准",
					// 	info1: "结算助手是为总包/派遣公司提供的财务管理与结算工具，旨在帮助总包/派遣公司的财务人员快速准确地核算工人工资、代理佣金及项目利润。",
					// 	title: "结算助手",
					// },


					{
						id: 5,
						url: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/伯才用人.svg",
						imgUrl: "http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/产品服务6.svg",
						info: "无需招聘  直接用人",
						info1: "伯才用人是新一代综合灵活用工平台，伯才用人的使命就是让企业用人像网约车一样简单，无需招聘、直接用人。",
						title: "伯才用人",
					},

				],
				// currentService: {
				// 	id: 1,
				// 	url: require("../../assets/bcSVG/ysdIcon.svg"),
				// 	info: "伯才稻田是一个专门服务同业合作伙伴的综合平台——一个专门服务代理的平台。平台为合作伙伴提供交付全流程的产品和服务，是伯才供应链产品矩阵中的旗舰产品。平台通过直签、联合派遣和战略合作等方式，严选上线项目，深度介入服务的每一个环节，为合作伙伴的顺利交付保驾护航。",
				// 	title: "伯才稻田",
				// 	img: require("../../assets/bcSVG/ysdService.svg"),
				// },
				bannerSwiperOption: {
					// 轮播图的配置选项
					loop: true,
					// width: 1920,
					effect: "fade",
					// direction: "vertical",
					fadeEffect: {
						crossFade: true,
					},
					autoplay: true,
					autoplayDisableOnInteraction: false,
					touchMoveStopPropagation: true,
					touchReleaseOnEdges: true,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				},
				bannerSwiperOption1: {
					// 轮播图的配置选项
					loop: true,
					// width: 1920,
					effect: "fade",
					// direction:'vertical',
					fadeEffect: {
						crossFade: true,
					},
					autoplay: true,
					autoplayDisableOnInteraction: false,
					touchMoveStopPropagation: true,
					touchReleaseOnEdges: true,

					pagination: {
						el: ".swiper-pagination1",
						clickable: true,
					},
				},
				partenshipSwiperOption: {
					loop: true,
					// width: 1000,
					effect: "coverflow",
					// direction:'vertical',
					slidesPerView: 1.2,
					centeredSlides: true,
					coverflowEffect: {
						rotate: 30,
						stretch: -30,
						depth: 100,
						modifier: 1,
						slideShadows: false,
					},
					autoplay: true,
					autoplayDisableOnInteraction: false,
					touchMoveStopPropagation: true,
					touchReleaseOnEdges: true,

					pagination: {
						el: ".swiper-pagination1",
						clickable: true,
					},
				},
				// timerSwiperOption: {
				// 	loop: true,
				// 	crossFade: false,
				// 	// autoplay: true,
				// 	touchMoveStopPropagation: true,
				// 	touchReleaseOnEdges: true,
				// 	pagination: {
				// 		el: "#timer-swiper-pagination",
				// 		clickable: true,
				// 	},
				// },
			};
		},
		// 计算属性
		computed: {},
		// 侦听器
		watch: {
			serviceActive(newv) {
				this.reset = false;
				this.serviceList.forEach((item) => {
					if (item.id == newv) {
						this.currentService = item;
					}
				});
				setTimeout(() => {
					this.reset = true;
				}, 0);
			},
			isHuman() {
				console.log(this.isHuman);
			},
		},
		beforeCreate() {
			console.log(this);
		},
		// 生命周期钩子   注：没用到的钩子请自行删除
		/**
		 * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
		 */
		created() {
			this.$message.config({
				top: `50%`,
				duration: 2,
			});
		},
		/**
		 * el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
		 * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.el 也在文档内。
		 */
		mounted() {
			this.getCooperativeImg();
			// let that = this;
			console.log(document.body.clientWidth);
			if (document.body.clientWidth <= 1200) {
				this.isMobileShow = true;
			} else {
				this.isMobileShow = false;
			}
			// console.log(document.querySelectorAll(".swiper-pagination-bullet"));
			var list = document.querySelectorAll(".swiper-pagination-bullet");
			var test = document.querySelectorAll(".tesst");
			this.$nextTick(() => {
				for (let i = 0; i < list.length; i++) {
					console.dir(test[i].cloneNode);
					// console.log(list[i].attributes);
					// let data = test[i].attributes.getNamedItem('role')
					// console.log(data);
					// list[i].attributes.setNamedItem(data);
					// console.log(list[i].attributes);
				}
			});
			this.$forceUpdate();
			// list.forEach((item)=>{
			//   // item.attributes.role = ''
			//  item.attributes.removeNamedItem('role')
			// //  item.attributes.setNamedItem('role=""')
			// //  console.log(result);
			//   // delete item.attributes['role']
			//   console.log(item.attributes);
			// })
		},
		// 组件方法
		methods: {
			changeBanner(e) {
				let bannerSwiper = this.$refs.bannerSwiper.swiper;
				console.log(bannerSwiper);
				if (e == 1) {
					bannerSwiper.slidePrev();
				} else {
					bannerSwiper.slideNext();
				}
			},
			changeTimer(e) {
				let timerSwiper = this.$refs.timerSwiper.swiper;
				if (e == 1) {
					timerSwiper.slideNext();
				} else {
					timerSwiper.slidePrev();
				}
			},

			getCooperativeImg() {
				files.keys().forEach((key) => {
					let names = path.basename(key, ".png"); //返回文件名 不含后缀名
					// console.log(files(key));
					let content = files(key).default || files(key);
					// console.log(content);
					if (names.indexOf("brand") != -1) {
						this.cooperativeImg.push(content);
					}
				});
				// console.log(this.cooperativeImg);
			},
			changeLocation() {
				// if (ind == 1) {
				// 	this.location = { lng: 113.772207, lat: 34.756724 };
				// } else {
				// 	this.location = { lng: 113.863823, lat: 34.571367 };
				// }
				// this.resets();
				// this.$forceUpdate();
			},
			preventDefault() {
				new Promise((resolve, reject) => {
					// document.body.style.overflow = "auto";
					resolve();
				}).then(() => {
					setTimeout(() => {
						let themark = Array.from(
							document.querySelectorAll(".ant-modal-wrap")
						);
						themark.forEach((item) => {
							item.addEventListener("mousewheel", function(e) {
								e.preventDefault();
							});
						});
					}, 100);
				});
			},
			showModal(e) {
				this.modalType = e;
				this.modalVisible = true;
				this.preventDefault();
				// document.body.style.overflow = 'auto';
			},
			showMobileModal(e) {
				if (e.target.type == "button") {
					this.modalType = e.target.dataset.type;
					this.modalVisible = true;
					this.preventDefault();
				}
			},
			cancelModal() {
				console.log("isnotok");
				//  document.body.style.overflow = '';
				new Promise((resolve, reject) => {
					// document.body.style.overflow = "";
					resolve();
				}).then(() => {
					this.modalVisible = false;
				});
			},
			async handleSubmit(e, type) {
				e.preventDefault();
				console.log(type);
				this.submitLoading = true;
				let {
					data
				} = await sendForm({
					...this.submitForm.getFieldsValue(),
					recordType: this.modalType,
				});
				setTimeout((e) => {
					console.log(e);
					console.log(this);
					this.submitLoading = false;
					this.verificationVisible = false;
					this.$refs.verification.isok = false;
					if (data.status == 200) {
						if (type == "mobile") {
							this.$message.success("提交成功");
							this.modalVisible = false;
						} else {
							this.isSubmitRight = true;
						}
					} else {
						this.$message.warning("未成功提交表单，请重试！");
					}
				}, 1000);
			},
			showVerification() {
				this.submitForm.validateFields((err, right) => {
					console.log(err);
					if (err == null) {
						this.verificationVisible = true;
					}
				});

				this.preventDefault();
			},
			cancelVerification() {
				this.verificationVisible = false;
				this.isSubmitRight = false;
				this.$refs.verification.isok = false;
				this.isHuman = false;
			},
			closeFormModal() {
				this.isSubmitRight = false;
				this.modalVisible = false;
			},
		},
	};
</script>

<style scoped lang="less">
	@keyframes move {
		0% {
			// transform:translateX(0);
			opacity: 0;
		}

		100% {
			left: 0;
			// transform:translateX(40px);
			opacity: 1;
		}
	}

	@keyframes show {
		0% {
			transform: rotate(0deg);
			// width: 0;
			opacity: 0;
		}

		100% {
			// width: 200px;
			// transform:translateX(40px);
			transform: rotate(90deg);
			opacity: 1;
		}
	}

	.mainContent {
		position: relative;
		// top: -81px;
		z-index: 1;

		.banner {
			position: relative;
			height: calc(100%);

			.swiper-container {
				position: relative;
				height: calc(100%);
			}

			.contralLeft {
				left: 0;
				border-radius: 0 50% 50% 0;
			}

			.contralRight {
				right: 0;
				border-radius: 50% 0 0 50%;
			}

			.contral {
				position: absolute;
				bottom: 0;
				z-index: 9;
				height: calc(100% - 80px);
				width: 100px;
				background-color: #fff;
				opacity: 0;
				transition: all 0.4s;

				&:hover {
					opacity: 0.3;
				}
			}

			#swiper {
				// overflow: hidden;
				width: 100vw;
				height: 100vh !important;

				// min-height: 720px;
				// max-height: 1080px;
				.swiper-wrapper {
					height: 100vh !important;

					.swiper-slide {
						position: relative;
						height: 100vh !important;
						min-height: 720px;

						// max-height: 1080px;
						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}

						#info {
							position: absolute;
							overflow: hidden;
							left: 0;
							top: 0;
							width: 100%;
							height: 100%;
							display: flex;
							text-align: center;
							flex-direction: column;
							justify-content: center;
							cursor: default;

							p {
								font-size: 80px;
								font-weight: 200;
								line-height: 1.2;
								color: #fff;
							}

							p:first-child {
								margin-bottom: 50px;
							}
						}
					}

					// >div:nth-of-type(2) {
					//   img {
					//       transform: rotateY(180deg);
					//   }
					// }
				}
			}

			/deep/ .paginationContainer {
				position: absolute;
				display: flex;
				justify-content: space-between;
				width: 100%;
				left: 0px;
				bottom: 64px;
				z-index: 10;

				.swiper-pagination {
					position: unset;
					display: flex;
					width: unset;
					align-items: center;
					margin: 0 10px;

					.swiper-pagination-bullet {
						position: relative;
						width: 8px;
						height: 8px;
						border-radius: 4px;
						margin: 0 12px;
						// background-color: rgba(255, 255, 255, 0.3);
						background-color: rgba(255, 255, 255, 0.6);
						opacity: 1;
						transition: width 0.1s;
						-webkit-tap-highlight-color: transparent;

						&:focus-visible {
							outline: 0;
							border: none;
						}

						&::after {
							content: "";
							position: absolute;
							left: 0;
							top: 0;
							transform: translate(-25%, -25%);
							width: 250%;
							height: 250%;
						}
					}

					.swiper-pagination-bullet-active {
						position: relative;
						height: 8px;
						width: 30px;
						background-color: #027aff;

						&:focus {
							border: none;
						}

						&:active {
							border: none;
						}

						&:focus-visible {
							outline: 0;
							border: none;
						}

						// &::after {
						// 	content: "";
						// 	position: absolute;
						// 	// display: block;
						// 	width: 24px;
						// 	height: 24px;
						// 	transform: translate(-50%, -38%);
						// 	border-radius: 50%;
						// 	border: 2px solid #027aff;
						// }
					}
				}

				.w {
					display: flex;
					justify-content: center;
					// > span {
					// 	// display: none;
					// 	width: 44px;
					// 	height: 44px;
					// 	border-radius: 50%;
					// 	cursor: pointer;
					// }
					// > span:first-child {
					// 	background: url("../../assets/bcSVG/leftLine.svg") no-repeat center;

					// 	&:hover {
					// 		background: url("../../assets/bcSVG/leftBlue.svg") no-repeat center;
					// 	}
					// }
					// > span:last-child {
					// 	background: url("../../assets/bcSVG/rightLine.svg") no-repeat center;
					// 	&:hover {
					// 		background: url("../../assets/bcSVG/rightBlue.svg") no-repeat center;
					// 	}
					// }
				}
			}
		}

		.introduce {
			position: relative;
			padding: 140px 0 305px 0;
			// height: 670px;
			// background: url("../../assets/bcSVG/video.gif") no-repeat;
			background-size: 70% 80%;
			background-position: 100% 127%;

			.w {
				>div:first-child {
					font-size: 3.125em;
					line-height: 1;
					font-weight: 200;
					margin-bottom: 95px;
				}

				.introduceInfo {
					color: #888;

					p {
						line-height: 1.75;
						width: 750px;
						margin-bottom: 18px;
					}

					// line-height: 28px;
				}

				.operationList {
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					position: absolute;
					left: 0;
					bottom: 0;
					height: 225px;
					width: 1054px;
					background-color: #383838;
					padding-left: 360px;

					ul {
						// margin-top: 45px;
						// display: flex;
						// justify-content: space-around;
						overflow: hidden;

						li {
							float: left;
							font-size: 1.375em;
							padding: 6px 0;
							margin-right: 100px;
							border-bottom: 1px solid #fff;
							color: #fff;
						}
					}
				}
			}
		}

		.purpose {
			display: flex;
			width: 100vw;

			>div {
				flex: 1;
				padding: 130px 0;
				text-align: center;

				h4 {
					font-size: 50px;
					font-weight: 200;
					margin-bottom: 60px;
				}

				>div {
					display: flex;
					height: 100px;
					flex-direction: column;
					justify-content: space-around;
					align-items: center;
				}
			}

			>div:not(div:last-child) {
				border-right: 1px solid #eee;
			}
		}
	}

	// 关于伯才锚点样式
	.product {
		padding-bottom: 130px;
		background: #f6f6f6;

		.w {}

		h1 {
			margin: 90px 0;
		}

		.content {
			display: flex;
			position: relative;

			/deep/ .container {
				position: absolute;
				z-index: 9;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);

				.swiper-pagination1 {
					display: flex;
					flex-direction: column;
					// width: 54px;
					// height: 300px;
				}

				// background-color: #027aff;
				.swiper-pagination-bullet {
					position: relative;
					opacity: 1;
					margin-bottom: 32px;
					width: 44px;
					height: 44px;
					border-radius: 50%;
					overflow: hidden;
					box-shadow: 0 0 20px 0 #bbb;
					cursor: pointer;

					&:nth-child(1) {
						background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/伯才供应链.svg") no-repeat center;
						background-size: 104%;
					}

					&:nth-child(2) {
						background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/哪吒.svg") no-repeat center;
						background-size: 102%;
					}

					&:nth-child(3) {
						background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/职位云.svg") no-repeat center;
						background-size: 102%;
					}

					// &:nth-child(4) {
					// 	background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/稻田.svg") no-repeat center;
					// 	background-size: 102%;
					// 	background-position: center;
					// }

					&:nth-child(4) {
						background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/伯才用人.svg") no-repeat center;
						background-size: 102%;
					}

					&:nth-child(6) {
						background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/伯才用人.svg") no-repeat center;
						background-size: 102%;
					}
				}

				.swiper-pagination-bullet-active {
					transition: all 0.3s;
					transform: scale(1.2);
				}
			}

			#serviceSwiper {
				position: relative;

				.swiper-wrapper {
					position: unset;
				}

				.swiper-slide {
					display: flex;
					justify-content: space-around;
					padding-right: 50px;

					// width: ;
					.infoBox {
						width: 506px;

						.icon {
							width: 80px;
							height: 80px;
							border-radius: 20px;
							overflow: hidden;
							margin-bottom: 30px;

							// background-color: #00cb00;
							// box-shadow: 0 0 20px 0 #ddd;
							img {
								width: 80px;
								height: 80px;
							}
						}

						.title {
							font-size: 24px;
							line-height: 45px;
							margin: 20px 0 8px 0;
						}

						.info {
							margin-bottom: 32px;
							font-size: 16px;
							line-height: 32px;
							white-space: break-all;
						}

						.info1 {
							color: #666;
							font-size: 16px;
							line-height: 32px;
							white-space: break-all;
						}
					}

					.img {
						display: flex;
						align-items: center;
						width: 440px;
						height: 100%;

						// margin-left: 100px;
						img {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
	}

	.partenship {
		border: 1px solid transparent;
		overflow: unset !important;
		position: relative;
		// overflow: hidden !important;

		.content {
			display: flex;
			justify-content: space-between;
			padding-bottom: 160px;

			>div {
				width: 380px;
				height: 446px;
				border-radius: 10px;
				text-align: center;
				background-color: #f5f5f5;
				padding-top: 60px;
				transition: all 0.2s;

				&:hover {
					background-color: #fff;
					box-shadow: 0 5px 20px 5px #eee;
				}

				// border: 1px solid #027aff;
				i {
					font-size: 100px;
					color: #666;
				}

				h4 {
					// margin-top: 240px;
					margin-bottom: 14px;
					font-size: 16px;
					font-weight: bold;
				}

				p {
					font-size: 14px;
					margin-bottom: 39px;
					color: #666666;
				}

				button {
					width: 186px;
					height: 40px;
					font-size: 16px;
					color: #fff;
					background: #027aff;
					border-radius: 7px;
				}
			}
		}

		.middlebanner {
			height: 830px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		/deep/ .aboutus {
			position: absolute;
			display: block;
			left: 50% !important;
			transform: translateX(-50%) !important;
			bottom: 0;
			height: 80px;
			width: 100vw;
			background-color: #fff;
			box-shadow: 0px 0px 24px 0px rgba(190, 190, 190, 0.5);
			z-index: 120;

			.ant-anchor-wrapper {
				width: 880px;
				margin: 0 auto;
				padding: 0;
				// padding: 0 160px;
			}

			.ant-anchor {
				margin: 0 auto;
				display: flex;
				padding: 0;
				justify-content: space-between;
				height: 80px;
				align-items: center;
				text-align: center;

				.ant-anchor-ink {
					display: none !important;
				}

				>div {
					padding: 0;

					a {
						display: block;
						color: #4d575e;
						overflow: unset;
						font-size: 16px;

						&:hover {
							color: #0f89f0 !important;
						}
					}

					.ant-anchor-link-title-active {
						// color: # !important;
						position: relative;
						color: #007aff;
					}
				}
			}
		}
	}

	.clearflow::after {
		// 清除浮动
		content: "";
		display: block;
		clear: both;
	}

	.fBox {
		overflow: hidden;
		width: 100vw;

		// padding-bottom: 30px;
		h1 {
			margin-top: 80px;
			margin-bottom: 60px;
			text-align: center;
			font-size: 32px;
			// font-weight: 600;
			color: #333;
		}
	}

	.businessScope {
		padding-bottom: 72px;

		.content {
			display: flex;
			justify-content: start;

			.left {
				flex: 1;
				// width: 647px;
				// height: 536px;
				margin-right: 95px;
				// background-color: pink;
			}

			.right {
				flex: 1;
				// width: 460px;
				display: flex;
				flex-direction: column;
				justify-content: center;

				h4 {
					font-size: 24px;
					margin: 20px 0 42px 0;
				}

				p {
					color: #999;
					font-size: 18px;
					margin-bottom: 8px;
					font-weight: 400;
				}

				>div {
					width: 203px;
					height: 94px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				>div:first-of-type {
					width: 170px;
					margin-top: 36px;
					margin-bottom: -5px;
				}
			}
		}
	}

	.brand {
		background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/cooperativeBrandBg.webp") no-repeat;
		background-size: cover;
		// background-color: #f6f6f6;
		padding-bottom: 160px;

		h1 {
			margin: 82px 0 12px 0;
		}

		>span {
			display: block;
			text-align: center;
			font-size: 14px;
			color: #999;
			margin-bottom: 70px;
		}

		.content {
			ul {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				li {
					position: relative;
					// float: left;
					width: 15.5%;
					height: 88px;
					margin-top: 16px;
					border-radius: 8px;
					transition: all 0.2s;
					overflow: hidden;
					border: 1px solid #d3cfcf;
					// &:not(li:nth-child(6n)) {
					// 	margin-right: 16px;
					// }

					&:hover {
						background-color: rgba(254, 254, 254, 0.3);
						box-shadow: 0px 0px 12px 3px #ddd;
					}

					img {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: 190px;
						height: 92px;
					}
				}
			}

			span {
				float: right;
				font-size: 1em;
				line-height: 20px;
				margin-top: 16px;
				margin-right: 40px;
			}
		}
	}

	.aboutbocai {
		.yuanjingshiming {
			padding-bottom: 120px;

			h1 {
				margin-bottom: 160px;
			}

			background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/愿景及使命.webp") no-repeat center;
			background-size: 100% 100%;

			.content {
				display: flex;
				// justify-content: space-between;
				justify-content: center;
				flex-wrap: wrap;

				>div {
					// width: 580px;
					flex: 1;
					height: 212px;
					padding: 24px;
					margin: 0 20px;
					background: rgba(255, 255, 255, 0.8);

					h4 {
						text-align: center;
						margin-bottom: 25px;
						font-size: 24px;
					}

					div {
						width: 244px;
						margin: 40px auto 0;
						text-align: center;
					}

					p {
						width: 252px;
						// color: #666;
						line-height: 20px;
						font-size: 14px;
						margin: 0 auto 8px;
						text-align: center;
					}

					// &:last-child {
					// 	div {
					// 		width: 144px;
					// 		margin: 40px auto 0;
					// 	}
					// }
				}
			}
		}

		.enterpriseCulture {
			text-align: center;

			>h1 {
				margin-bottom: 90px;
			}

			.content {
				// margin-top: 50px;
			}

			.content1 {
				height: 230px;
				background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/企业文化.jpg") no-repeat center;
				// background-position: -10px 0;
				background-size: cover;

				.headline {
					padding-top: 60px;
					// color: #fff;
				}

				p {
					// color: #fff;
					font-size: 18px;
					margin-top: 32px;
					margin-bottom: 70px;
				}
			}

			.content2 {
				height: 340px;

				// background-color: #76d4ab;
				.headline {
					padding-top: 0px;
				}

				ul {
					display: flex;
					justify-content: space-between;
					height: 140px;
					margin: 90px 0;

					li {
						flex: 1;
						display: flex;
						justify-content: center;
						align-items: center;
						height: 100%;
						transition: all 0.2s;
						border-radius: 4px;
						// color: #666;
						cursor: default;

						&.active {
							color: #fff;
							background-color: #027aff;

							i {
								color: #fff;
							}
						}

						// background: #027aff;
						i {
							margin-right: 10px;
							font-size: 30px;
							color: #007aff;
							transition: all 0.3s;
						}

						span {
							font-size: 22px;
						}

						&:not(:last-child) {
							border-right: 1px solid #ededed;
						}
					}
				}
			}

			.headline {
				padding-top: 60px;
				font-size: 24px;
				position: relative;
				// &::after {
				// 	content: "";
				// 	position: absolute;
				// 	width: 28px;
				// 	height: 2px;
				// 	background: #027aff;
				// 	bottom: -14px;
				// 	left: 50%;
				// 	transform: translateX(-50%);
				// }
			}
		}

		.developmentHistory {
			.w {
				width: 800px;
			}

			h1 {
				margin-bottom: 134px;
			}

			.head {
				overflow: hidden;

				height: 400px;
				background: #f5f5f5;

				.timeAxle {
					display: flex;
					position: relative;
					justify-content: space-between;

					&::after {
						content: "";
						position: absolute;
						width: 95%;
						height: 1px;
						bottom: 12px;
						left: 24px;
						background-color: #00cb00;
					}

					.active {
						background-color: #027aff;

						& span {
							color: #027aff;
						}
					}

					li {
						position: relative;
						cursor: pointer;
						width: 24px;
						height: 24px;
						z-index: 2;
						background-color: #fff;
						border-radius: 50%;
						border: 2px solid #027aff;

						&:nth-child(3),
						&:nth-child(4) {
							p {
								width: 128px;
							}
						}

						p {
							display: block;
							line-height: 33px;
							font-size: 24px;
							width: auto;
							position: absolute;
							bottom: 40px;
							left: 50%;
							transform: translateX(-50%);
						}
					}
				}
			}

			.body {
				padding: 50px 0;
				min-height: 320px;

				.title {
					font-size: 32px;
					width: 600px;
					padding-bottom: 8px;
					line-height: 45px;
					border-bottom: 1px solid #cccccc;
				}

				.content {
					font-size: 18px;
					line-height: 32px;
					margin-top: 15px;

					p {
						color: #333;
					}
				}
			}
		}

		.developmentHistory1 {
			background-color: #f6f6f6;
			padding-bottom: 60px;

			.content {
				margin: 0 auto;
				// width: 710px;
				position: relative;
				left: 378px;

				// border-left: 1px solid #000;
				&::before {
					content: "";
					position: absolute;
					height: calc(100% - 32px);
					width: 1px;
					background-color: #aeaeae;
					left: 0;
					top: 15px;
				}

				>li {
					>ul {
						position: relative;
						margin-bottom: 50px;

						>span {
							font-size: 28px;
							line-height: 40px;
							position: absolute;
							left: 0;
							// color: #555;
							top: -9px;
							transform: translateX(-124px);
						}

						>li {
							margin-bottom: 18px;
							padding-left: 68px;
							position: relative;
							color: #333;

							&::before {
								content: "";
								position: absolute;
								width: 14px;
								height: 14px;
								background-color: #c7c7c7;
								border-radius: 50%;
								left: -6.5px;
								top: 50%;
								transform: translateY(-50%);
							}
						}
					}
				}
			}
		}

		.workSpace {
			height: 660px;

			.web-font-content-info {
				-webkit-text-stroke-width: 0.1px;
			}

			.content {
				display: flex;
				height: 290px;

				.left {
					// flex: 1;
					position: relative;
					// height: 290px;
					width: 478px;
					background-color: #027aff;
					display: flex;
					justify-content: space-between;
					margin-right: 42px;
					padding: 84px 0 0 64px;

					// background-color: #34cd8b;
					&::after {
						content: "";
						position: absolute;
						width: 20px;
						height: 20px;
						right: -10px;
						top: 50%;
						transform: translateY(-50%) rotate(45deg);
						background-color: #027aff;
						border: 1px solid #eee;
						border-left: 1px solid transparent;
						border-bottom: 1px solid transparent;
						z-index: 1;
					}

					.web-font-content-info {
						color: #fff;

						i {
							font-size: 34px;
						}

						.title {
							color: #fff;
							font-size: 18px;
							margin-bottom: 32px;
						}

						p {
							display: flex;
							font-size: 14px;
							margin-bottom: 14px;

							i {
								font-size: 20px;
								margin-right: 10px;
								line-height: 20px;
								font-weight: 400;
							}
						}
					}
				}

				.right {
					width: 680px;
				}
			}
		}

		.yewujiagou {
			background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/Image 1.webp") no-repeat center;
			background-size: cover;

			.content {
				height: 536px;
				background: url("../../assets/bcSVG/架构图.svg") no-repeat center;
				background-size: 98% 98%;
				margin-bottom: 90px;
			}
		}

		.guanyubocai {
			padding-bottom: 88px;

			.tagBox {
				text-align: center;

				span {
					font-size: 16px;
					line-height: 22px;
					padding: 7px 20px;
					margin-right: 12px;
					border-radius: 999px;
				}
			}

			.content {
				display: flex;
				justify-content: space-between;
				margin-top: 94px;

				.web-font-content-info {
					-webkit-text-stroke-width: 0.1px;
				}

				.left {
					width: 580px;
					height: 326px;
					// align-items: center;
					margin-right: 40px;

					p {
						// font-weight: 100;
						font-size: 18px;
						line-height: 30px;
						margin-bottom: 43px;
						color: #666666;
					}
				}

				.right {
					width: 580px;
					height: 326px;

					img {
						width: 100%;
						height: 100%;
					}

					// background-color: #007aff;
					// background: url("../../assets/bcSVG/gsjj.jpg") no-repeat center;
					// background-size: cover;
				}
			}
		}
	}

	/deep/ .ant-modal-content {
		.ant-modal-body {
			padding: 40px;
			// flex-direction: column;
			align-items: center;

			.modalTitle {
				font-size: 24px;
				font-weight: 600;
				text-align: center;
			}

			.modalContent {
				font-size: 14px;
				margin-bottom: 24px;
				color: #999;
			}

			.ant-form-item {
				margin-bottom: 16px;
			}

			.ant-form-item-label {
				line-height: 1.5;
				margin-bottom: 8px;

				label {
					color: #333;
				}
			}

			.submitContiner {
				padding-top: 16px;
				text-align: center;
			}

			.success {
				text-align: center;
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-top: calc(50% - 80px);
				min-height: 487px;
				height: 100%;

				.icon-tijiaochenggong {
					font-size: 90px;
					// text-align: center;
					color: #0aaa74;
				}

				p {
					font-size: 16px;
					margin-bottom: 0;
					line-height: 2;

					&:first-of-type {
						color: #333;
						font-weight: 600;
					}
				}
			}
		}

		.ant-modal-footer {
			border-top: 0px solid #000 !important;
			text-align: center;
			padding-bottom: 40px;
			padding-top: 0;
		}
	}

	/deep/ .ant-drawer-content {
		border-radius: 16px 16px 0px 0px;

		.ant-drawer-body {
			padding: 45px;

			.modalTitle {
				text-align: center;
				font-size: 20px;
				font-weight: 600;
				line-height: 1.5;
			}

			.modalContent {
				color: #999;
			}

			.ant-form-item {
				margin-bottom: 1rem;

				.ant-form-item-label {
					label {
						color: #333;
					}
				}
			}

			.submitContiner {
				text-align: center;
			}
		}
	}
</style>
<style lang="less">
	 .aboutus {
		position: absolute;
		display: block;
		left: 50% !important;
		transform: translateX(-50%) !important;
		bottom: 0;
		height: 80px;
		width: 100vw;
		background-color: #fff;
		box-shadow: 0px 0px 24px 0px rgba(190, 190, 190, 0.5);
		z-index: 120;
	
		.ant-anchor-wrapper {
			width: 880px;
			margin: 0 auto;
			padding: 0;
			// padding: 0 160px;
		}
	
		.ant-anchor {
			margin: 0 auto;
			display: flex;
			padding: 0;
			justify-content: space-between;
			height: 80px;
			align-items: center;
			text-align: center;
	
			.ant-anchor-ink {
				display: none !important;
			}
	
			>div {
				padding: 0;
	
				a {
					display: block;
					color: #4d575e;
					overflow: unset;
					font-size: 16px;
	
					&:hover {
						color: #0f89f0 !important;
					}
				}
	
				.ant-anchor-link-title-active {
					// color: # !important;
					position: relative;
					color: #007aff;
				}
			}
		}
	}
</style>